import { useNow } from 'next-intl';

export default function useCountdown(date: string | number | Date): number {
  const now = useNow({
    updateInterval: 1000,
  });

  let endtime: number;

  if (typeof date === 'string' || typeof date === 'number') {
    endtime = new Date(date).getTime();
  } else {
    endtime = date.getTime();
  }
  const countDown = endtime - now.getTime();
  return countDown > 0 ? countDown : 0;
}
